import { css } from '@emotion/react';
import { Spinner } from 'components/Spinner';
import React, { MouseEvent, ReactNode } from 'react';
import { theme } from 'styles/theme';

export const Button = ({
	children,
	onClick,
	outline,
	type,
	block,
	small,
	large,
	isProcessing,

	ghost,
	ghostPrimary,

	icon,
	square,

	disabled,
}: {
	children: ReactNode;
	onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
	outline?: boolean;
	type?: 'submit' | 'button' | 'reset' | undefined;
	block?: boolean;
	small?: boolean;
	large?: boolean;
	isProcessing?: boolean;

	ghost?: boolean;
	ghostPrimary?: boolean;

	icon?: ReactNode;
	square?: boolean;

	disabled?: boolean;
}) => {
	return (
		<button
			css={css`
				background: ${theme.color.primary['400']};
				box-shadow: 0 2px 4px 0 rgba(103, 120, 255, 0.25);
				border-radius: 8px;
				font-size: 14px;
				line-height: 20px;
				color: #fff;
				border: 0;
				height: 44px;
				padding: 0 24px;
				font-weight: 600;
				display: inline-flex;
				align-items: center;
				justify-content: center;

				flex-shrink: 0;

				&:active {
					outline: none;
					opacity: 0.5;
				}

				&:focus {
					outline: none;
				}

				${small &&
				css`
					height: 36px;
					font-size: 13px;
					line-height: 20px;
					padding: 0 16px;
				`}

				${square &&
				css`
					padding: 0;
					width: ${small ? 36 : 44}px;
				`};

				${large &&
				css`
					height: 48px;
				`}

				${block &&
				css`
					width: 100%;
				`}

				${outline &&
				css`
					background: #ffffff;
					border: 1px solid #e2e3e9;
					border-radius: 8px;
					color: ${theme.color.text['300']};
					box-shadow: none;

					&:hover {
						color: ${theme.color.text['400']};
						background: ${theme.color.primary['50']};
					}
				`}

				${ghost &&
				css`
					background: transparent;
					border: 1px solid transparent;
					border-radius: 8px;
					color: ${theme.color.text['300']};
					box-shadow: none;

					&:hover {
						color: ${theme.color.text['400']};
					}
				`}

				${ghostPrimary &&
				css`
					background: transparent;
					border: 1px solid transparent;
					box-shadow: none;
					color: ${theme.color.primary['400']};

					&:hover {
						background: ${theme.color.primary['50']};
					}
				`}

				${disabled &&
				css`
					opacity: 0.3;
				`}
			`}
			onClick={onClick}
			type={type}
			disabled={disabled}
		>
			{isProcessing ? (
				<span
					css={css`
						svg {
							width: 24px;
							height: 24px;
						}
					`}
				>
					<Spinner />
				</span>
			) : (
				<>
					{!!icon && (
						<div
							css={css`
								${!square &&
								css`
									margin-right: 8px;
								`}
							`}
						>
							{icon}
						</div>
					)}

					{children}
				</>
			)}
		</button>
	);
};
